import { DateTime } from 'luxon';
import { AccountingPeriodClose } from './accounting';

export namespace AccountingParsers {
  export type AccountingPeriodCloseJson = {
    id: string;
    closeDateTime: string;
    createdAt: string;
    createdBy?: number;
    deletedAt?: string;
    deletedBy?: number;
  };

  export function toAccountingPeriodClose(input: AccountingPeriodCloseJson): AccountingPeriodClose {
    return {
      id: input.id,
      closeDateTime: DateTime.fromISO(input.closeDateTime, { setZone: true }),
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
      createdBy: input.createdBy,
      deletedAt: input.deletedAt ? DateTime.fromISO(input.deletedAt, { setZone: true }) : undefined,
      deletedBy: input.deletedBy,
    };
  }
}
